import { combineReducers } from "redux";
import { FETCH_SONGS, SONG_SELECTED } from "../actions/constatnts";

const songsReducer = (state = [], action) => {
    switch( action.type ){
        case FETCH_SONGS:
            return action.payload;
        default:
            return state;
    }
}

const selectedSongsReducer = (selectedSong = null, action) => {
    switch(action.type){
        case SONG_SELECTED:
            return action.payload;
        default:
            return selectedSong;
    }
}

export default combineReducers({
    songs: songsReducer,
    selectedSongs: selectedSongsReducer
});